import { defineMessages } from 'react-intl';
import type { IntlShape } from 'react-intl';

import type { FlagsStateContainer } from '@confluence/flags/entry-points/FlagsStateContainer.ts';

const SYNC_BLOCK_ERROR_FLAG_ID = 'flush-sync-block-error';

const i18n = defineMessages({
	syncBlockErrorTitle: {
		id: 'editor-features.error.sourceSyncBlock.save.title',
		description: 'Error title when sync block updates fail to save',
		defaultMessage: 'Error saving synced block',
	},
	syncBlockErrorDescription: {
		id: 'editor-features.error.sourceSyncBlock.description',
		description: 'Error description when sync block updates fail to save',
		defaultMessage:
			'We failed to save your recent updates. Please check your connection and try again.',
	},
	syncBlockErrorRetry: {
		id: 'editor-features.error.syncBlock.retry',
		description: 'Retry button text for synced block error',
		defaultMessage: 'Retry',
	},
});

export const showFlushSyncBlockErrorFlag = (
	flags: FlagsStateContainer,
	intl: IntlShape,
	retry?: () => Promise<boolean>,
): void => {
	flags?.showErrorFlag({
		id: SYNC_BLOCK_ERROR_FLAG_ID,
		title: intl.formatMessage(i18n.syncBlockErrorTitle),
		description: intl.formatMessage(i18n.syncBlockErrorDescription),
		isAutoDismiss: true,
		actions: [
			{
				content: intl.formatMessage(i18n.syncBlockErrorRetry),
				onClick: async () => {
					flags.hideFlag(SYNC_BLOCK_ERROR_FLAG_ID);

					const retrySuccess = await retry?.();

					if (!retrySuccess) {
						showFlushSyncBlockErrorFlag(flags, intl, retry);
					}
				},
			},
		],
	});
};
